const CREATED = 'CREATED';
const ACCEPTED = 'ACCEPTED';
const DENIED = 'DENIED';
const FINISHED = 'FINISHED';
const CANCELED = 'CANCELED';
const OPEN = 'OPEN';
const PAID = 'PAID';
const VOIDED = 'VOIDED';

export const invoicesStatusTypes = {
  CREATED,
  ACCEPTED,
  DENIED,
  FINISHED,
  CANCELED,
  OPEN,
  PAID,
  VOIDED,
};

export const ordersStatusLabels = {
  [CREATED]: 'reports:statusOrdersTypes.CREATED',
  [ACCEPTED]: 'reports:statusOrdersTypes.ACCEPTED',
  [DENIED]: 'reports:statusOrdersTypes.DENIED',
  [FINISHED]: 'reports:statusOrdersTypes.FINISHED',
  [CANCELED]: 'reports:statusOrdersTypes.CANCELED',
  [OPEN]: 'reports:statusOrdersTypes.OPEN',
  [PAID]: 'reports:statusOrdersTypes.PAID',
  [VOIDED]: 'reports:statusOrdersTypes.CANCELED',
};

export const ordersStatusVariants = {
  [CREATED]: 'default',
  [ACCEPTED]: 'accepted',
  [DENIED]: 'denied',
  [FINISHED]: 'finished',
  [CANCELED]: 'error',
  [OPEN]: 'open',
  [PAID]: 'paid',
  [VOIDED]: 'error',
};

export const statusOrdersTypesOptions = [
  { label: ordersStatusLabels[CREATED], value: invoicesStatusTypes.CREATED },
  { label: ordersStatusLabels[ACCEPTED], value: invoicesStatusTypes.ACCEPTED },
  { label: ordersStatusLabels[DENIED], value: invoicesStatusTypes.DENIED },
  { label: ordersStatusLabels[FINISHED], value: invoicesStatusTypes.FINISHED },
  { label: ordersStatusLabels[CANCELED], value: invoicesStatusTypes.CANCELED },
  { label: ordersStatusLabels[OPEN], value: invoicesStatusTypes.OPEN },
  { label: ordersStatusLabels[PAID], value: invoicesStatusTypes.PAID },
  { label: ordersStatusLabels[VOIDED], value: invoicesStatusTypes.VOIDED },
  { label: 'common:forms.allViews', value: '' },
];
